export default __webpack_public_path__ + "static/media/politique-de-risque.6ff2efff.png";